 import "./vgong-block.css";

import {vgongBlockWrapperTemplate} from "./templates/vgong-block-wrap.js";
import {vgongBlocFirstTemplate} from "./templates/vgong-block-first-video.js";

//import vgongBlockData from "./data/vgong-block.json";

import {placeCarousel} from "../carousel/carousel.js";


// Ensure you have `fetch` available, or use a polyfill if needed
(async () => {
  try {
    // Access the global `vgngDataUrl` variable set by PHP
    const vgongDataUrl = window.vgngDataUrl;
    if (!vgongDataUrl) {
        //return if no data is fetched;
        console.log('!vgongDataUrl');
        return;
    }
    // Fetch the JSON data from the URL
    const response = await fetch(vgongDataUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    // Parse the JSON response
    const data = await response.json();
    //console.log('Fetched Data:', data);

    // Use the data in your component
    loadVgongBlockData(data);
    
  } catch (error) {
    console.error('Error fetching data:', error);
  }
})();


function vgongBlockComponent(blockData){
    let vgongBlockOptionalClasses = blockData['carousel_info'].classes;
    vgongBlockOptionalClasses += blockData['carousel_info'].row_position ? ' row-' + blockData['carousel_info'].row_position : '';
    
    let vgongBlockWrapperElement = vgongBlockWrapperTemplate(vgongBlockOptionalClasses);
    
    return vgongBlockWrapperElement;
}

function loadVgongBlockData(blockData){
    let feedWrapperElement;
    if ( $('#vgong-home-block').length ){
        feedWrapperElement = $('#vgong-home-block');
        //console.log('feedWrapperElement ================ ', feedWrapperElement , blockData['carousel_info'].id);
    } else {
        feedWrapperElement = $('.base-grid');
        //console.log('feedWrapperElement 3 ================ ', feedWrapperElement , blockData['carousel_info'].id);
    }
    feedWrapperElement.append(vgongBlockComponent(blockData));
    //console.log('blockDataID', blockData['carousel_info'].id);
    //load first video
    let firstVideoUrl = blockData['item_0'].href;
    let firstVideoImgSrc = blockData['item_0'].img_src;
    let firstVideoTitle = blockData['item_0'].item_title;
    let firstVideolabelText = blockData['item_0'].label_text;
    let firstVideoElement = vgongBlocFirstTemplate(firstVideoUrl, firstVideoImgSrc, firstVideoTitle, firstVideolabelText);
    $('#vgong-block').append(firstVideoElement);
    
    //load carousel
    placeCarousel('#' + blockData['carousel_info'].id, blockData, 1);    
}

//loadVgongBlockData(vgongBlockData);


//console.log('VGONG block working');
